var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-image',{attrs:{"src":_vm.src,"rounded":_vm.rounded,"fit":"cover"}},[_c('div',{staticClass:"image-placeholder",attrs:{"slot":"error"},slot:"error"},[_c('img',{attrs:{"src":require("@/assets/images/avatar.png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }